module.exports = __webpack_public_path__ + "static/img/steps_qt2.b699b9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/steps_qt2.png
// module id = 340
// module chunks = 1